import React from 'react';
import { FormGroup, Input } from 'src/components/ui';
import useTestId from '../../hooks/useTestId';

function CheckboxToggleButtonField(props) {
  const {
    formData,
    disabled,
    fieldPathId: { $id, path },
    schema: { title, color = 'secondary', checkedColor = 'success' },
    uiSchema: { 'ui:readonly': uiReadonly, 'ui:checkboxHidden': checkboxHidden },
    required,
    readonly: propReadOnly,
    onChange: propOnChange,
  } = props;

  const readonly = uiReadonly || propReadOnly;
  const testIdProps = useTestId($id);

  const currentColor = (formData && checkedColor ? checkedColor : color) || 'secondary';

  function onChange({ target: { value, checked } }) {
    propOnChange(checked, path);
  }

  return (
    <FormGroup disabled={readonly || disabled} check className="checkbox-toggle-button-field">
      <label
        className={`control-label checkbox btn btn-${currentColor} ${checkboxHidden ? 'checkbox-hidden' : ''} ${formData ? 'checked' : ''}`}
        htmlFor={$id}
      >
        <Input id={$id} {...testIdProps} type="checkbox" disabled={readonly || disabled} required={required} checked={!!formData} onChange={onChange} />
        {title}
      </label>
    </FormGroup>
  );
}

export default CheckboxToggleButtonField;
